import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { registerUser } from '../utils/requests';
import { registerUserSuccess, registerUserFailed } from '../actions/registerUser';

export function* registerUserWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.REGISTER_USER_REQUEST, registerUserRequestWatcher);
}



function* registerUserRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(registerUser, payload);

      yield put(registerUserSuccess(response.data));
      console.log("createdUser");
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      console.log("registerUserError: ",error.response);
      
      yield put(registerUserFailed(errorPayload));
    }
}

